import { ApiJob, ApiJobContent } from "@common/api/v1.1/types/jobs";
import { AuthState, JobState, State } from "../types";

export interface LoadJobStartAction {
  jobId: string;
  type: "LOAD JOB START";
}
export interface LoadJobSuccessAction {
  contents: Array<ApiJobContent>;
  job: ApiJob;
  type: "LOAD JOB SUCCESS";
}
export interface LoadJobFailedAction {
  error: Error;
  jobId: string;
  type: "LOAD JOB FAILED";
}

export const loadJobStart = (state: State, action: LoadJobStartAction): State => {

  if (state.auth.state !== AuthState.loggedIn) {
    return state;
  } else if (state.job.state === JobState.loading && state.job.jobId === action.jobId) {
    return state;
  } else if (state.job.state === JobState.ready && state.job.job.id === action.jobId) {
    return state;
  }
  let jobs = state.jobs;
  if (action.jobId in state.jobs) {
    jobs = {
      ...state.jobs,
      [action.jobId]: {
        ...state.jobs[action.jobId],
        override: {
          ...state.jobs[action.jobId].override,
          claimed_by: {
            claimed_until: new Date().getTime(),
            email: state.auth.user.email,
            id: state.auth.user.id,
            name: state.auth.user.name,
          },
        },
      },
    };
  }
  return {
    ...state,
    job: {
      authString: state.auth.authString,
      jobId: action.jobId,
      state: JobState.loading,
    },
    jobs,
    sidebarVisible: false,
  };
};
export const loadJobFailed = (state: State, action: LoadJobFailedAction): State => {
  return {
    ...state,
    job: {
      error: action.error.message,
      jobId: action.jobId,
      state: JobState.failed,
    },
    sidebarVisible: true,
  };
};
export const loadJobSuccess = (state: State, action: LoadJobSuccessAction): State => {
  if (state.auth.state !== AuthState.loggedIn) {
    return state;
  }
  if (action.job.id in state.jobs && state.jobs[action.job.id].override) {
    delete state.jobs[action.job.id].override?.claimed_by;
  }
  let jobs = state.jobs;
  if (action.job.id in state.jobs) {
    jobs[action.job.id] = {
      data: action.job,
      override: state.jobs[action.job.id]?.override,
    }
  }
  return {
    ...state,
    job: {
      authString: state.auth.authString,
      contents: action.contents,
      job: action.job,
      state: JobState.ready,
    },
    jobs: jobs,
    sidebarVisible: false,
  };
};
